import React, { useEffect, useRef } from 'react';
import { ThemeProvider, createTheme } from '@mui/material';
import { SnackbarProvider } from 'notistack';
import { IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import Router from './Routes';
import { useDispatch, useSelector } from 'react-redux';

function AppContext() {
  const dispatch = useDispatch()
  const { currentTheme, mode } = useSelector(state => state.theme)
  const counting = useSelector(state => state.progress.counting)

  useEffect(() => {
      if (!counting) return

      let valorAcumulado = 0
      const totalDuration = 60000

      const interval = setInterval(() => {
          valorAcumulado += 1000
          const percentage = (valorAcumulado / totalDuration) * 100
          if (percentage >= 100) {
              valorAcumulado = 0
              dispatch({ type: 'UPDATE_PROGRESS', progress: { progressValue: 0, shouldRefetch: true, counting: false }})
          } else {
              dispatch({ type: 'UPDATE_PROGRESS', progress: { progressValue: percentage } })
          }
      }, 1000)
      return () => {
          clearInterval(interval)
      }
  }, [counting])

  const notistackRef = useRef();
  const onClickDismiss = key => () => {
    notistackRef.current.closeSnackbar(key);
  }

  if (mode === "dark") {
    document.documentElement.classList.add('dark')
  } else {
    document.documentElement.classList.remove('dark')
  }


  return (
    <div className="App">
      <ThemeProvider
        theme={currentTheme}>

        <SnackbarProvider
          maxSnack={3}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
          }}
          ref={notistackRef}
          action={(key) => (
            <IconButton size="small" onClick={onClickDismiss(key)}>
              <CloseIcon />
            </IconButton>
          )}
        >
          <Router />
        </SnackbarProvider>

      </ThemeProvider>
    </div>
  );
}

export default AppContext;